<template>
  <section
    class="hub-accordion"
    :class="{ 'hub-accordion--open': open }"
  >
    <button
      type="button"
      class="hub-accordion__trigger"
      :aria-expanded="String(open)"
      @click="toggle"
    >
      <span class="hub-accordion__lead">
        <span
          v-if="icon"
          class="hub-accordion__icon"
        >
          <OmtIcons
            :name="icon"
            size="sm"
            color="var(--colors-light-primary-navy-blue)"
          />
        </span>
        <OmtTypography as="h2-bold">{{ title }}</OmtTypography>
      </span>
      <span class="hub-accordion__action">
        <OmtTypography
          v-if="toggleLabel"
          as="l2"
          class="hub-accordion__label"
          >{{ open ? hideLabel : toggleLabel }}</OmtTypography
        >
        <OmtIcons
          :name="open ? 'chevron-up' : 'chevron-down'"
          size="sm"
          color="var(--colors-light-primary-navy-blue)"
        />
      </span>
    </button>
    <p
      v-if="description && open"
      class="hub-accordion__description"
    >
      {{ description }}
    </p>
    <div
      v-show="open"
      class="hub-accordion__content"
    >
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "HubAccordion",
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: "" },
    description: { type: String, default: "" },
    toggleLabel: { type: String, default: "" },
    hideLabel: { type: String, default: "Ocultar" },
    defaultOpen: { type: Boolean, default: false }
  },
  data() {
    return {
      open: this.defaultOpen
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    }
  }
};
</script>

<style scoped>
.hub-accordion {
  background: #eef0f6;
  border-radius: 12px;
  padding: 16px;
}

.hub-accordion__trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  text-align: left;
}

.hub-accordion__lead,
.hub-accordion__action {
  display: flex;
  align-items: center;
  gap: 12px;
}

.hub-accordion__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #e4eaf6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.hub-accordion__label {
  color: var(--colors-light-primary-navy-blue);
  display: none;
}

.hub-accordion__description {
  margin: 12px 0 16px;
  color: var(--colors-light-primary-gray1);
  font-size: 14px;
  line-height: 20px;
}

.hub-accordion__content {
  margin-top: 16px;
}

@media screen and (min-width: 1024px) {
  .hub-accordion__label {
    display: inline;
  }
}
</style>
